import { makeStyles, mergeClasses } from '@fluentui/react-components';

import { spacing } from '@/theme/tokens';

const STATE_COLORS: Record<string, { fg: string; bg: string }> = {
  New: {
    fg: 'var(--colorPaletteRedForeground1)',
    bg: 'var(--colorPaletteRedBackground2)',
  },
  Acknowledged: {
    fg: 'var(--colorPaletteMarigoldForeground1)',
    bg: 'var(--colorPaletteMarigoldBackground2)',
  },
  Closed: {
    fg: 'var(--colorPaletteGreenForeground1)',
    bg: 'var(--colorPaletteGreenBackground2)',
  },
};

const FALLBACK = {
  fg: 'var(--colorNeutralForeground3)',
  bg: 'var(--colorNeutralBackground3)',
};

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    paddingLeft: spacing.s,
    paddingRight: spacing.s,
    paddingTop: spacing.xxs,
    paddingBottom: spacing.xxs,
    borderRadius: 'var(--borderRadiusCircular)',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
});

interface StateBadgeProps {
  state: string;
  className?: string;
}

export function StateBadge({ state, className }: StateBadgeProps) {
  const classes = useStyles();
  const colors = STATE_COLORS[state] ?? FALLBACK;
  return (
    <span
      className={mergeClasses(classes.root, className)}
      style={{ color: colors.fg, backgroundColor: colors.bg }}
    >
      {state}
    </span>
  );
}
